<div class="spinner-container" role="status" aria-label="Cargando">

  <div class="spinner-dots">

    <span class="spinner-dot"></span>
    <span class="spinner-dot"></span>
    <span class="spinner-dot"></span>

  </div>

  <span class="spinner-text">
    Cargando...
  </span>

</div>